import type { ReactNode } from 'react';

type Props = {
  label: ReactNode;
  required?: boolean;
  htmlFor?: string;
};

const VNFieldTopLabel = ({ label, required = false, htmlFor }: Props) => (
  <label className="vn-field-top-label" htmlFor={htmlFor}>
    {label}
    {required ? <span className="vn-field-top-label__asterisk"> *</span> : ''}
  </label>
);

export default VNFieldTopLabel;
